export const tradesReportLocation = "/reports/tradebookreport"